import { mediaFormats } from '../constants';
function isHls(url) {
    return url.includes('.m3u8');
}
function removeM3UExtension(url) {
    const m3uIndex = url.indexOf('.m3u');
    return m3uIndex > 0 ? url.slice(0, m3uIndex) : url;
}
export function transformMislabelledHlsStreams(stream) {
    if (stream.format === mediaFormats.hls) {
        return stream;
    }
    const nextStream = { ...stream };
    if (isHls(nextStream.url)) {
        nextStream.isHlsFormatIncorrect = true;
    }
    const transformedUrl = removeM3UExtension(nextStream.url);
    if (transformedUrl !== nextStream.url) {
        nextStream.url = transformedUrl;
        nextStream.removedM3UExtension = true;
    }
    return nextStream;
}
